import React, { FunctionComponent } from "react";
import { useContentStyles } from "./useContentStyles";
import { useTranslate } from "../../service/translation";
import { useCookies } from "react-cookie";

import {
    Box, FormControl, FormControlLabel,
    Grid, Link, List, ListItem, ListItemIcon, ListItemText,
    Paper, Radio, RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import Bullet from "@material-ui/icons/FiberManualRecord";

interface CookiesContentProps {
}

const CookiesContent: FunctionComponent<CookiesContentProps> = (props: CookiesContentProps) => {
    const cookieName = 'europarlcookiepolicysagreement';
    const classes = useContentStyles();
    const translate = useTranslate();
    const [cookies, setCookie] = useCookies<any>([cookieName]);

    const handleCookies = (event:any) => {
        const expiryTime = (new Date()).getTime() + (1000 * 3600 * 24 * 180 );
        const expiryDate = new Date(expiryTime);
        setCookie(cookieName, event.target.value , { path: "/", expires: expiryDate  });
    }

    return (
        <Grid container className={classes.page} id="main-content">
            <Grid container className={classes.pageWrapper}>
                <Grid item className={classes.staticPageContainer}>
                    <Typography gutterBottom variant={"h1"} component={"h1"}>
                        Cookies policy
                    </Typography>
                    <Box className={classes.cookiesWidget}>
                        { cookies[cookieName] === "1" &&
                            <Typography variant={"body1"} component={"p"}>
                                {translate("cookies.message.cookiesWidgetAccepted")}
                            </Typography>
                        }

                        { cookies[cookieName] === "0"  &&
                            <Typography variant={"body1"} component={"p"}>
                                {translate("cookies.message.cookiesWidgetRefused")}
                            </Typography>
                        }

                        { cookies[cookieName] !== "0"  && cookies[cookieName] !== "1" &&
                            <Typography variant={"body1"} component={"p"}>
                                {translate("cookies.message.cookiesWidgetNeither")}
                            </Typography>
                        }

                        <FormControl component="fieldset">
                            <RadioGroup aria-label={translate("cookies.message.cookiesWidgetAccepted")} name="cookiesAcceptance" defaultValue={cookies[cookieName]} onChange={handleCookies}>
                                <FormControlLabel value="0" control={<Radio color="primary" />} label={translate("cookies.message.cookiesWidgetRadio1")} />
                                <FormControlLabel value="1" control={<Radio color="primary" />} label={translate("cookies.message.cookiesWidgetRadio2")} />
                            </RadioGroup>
                        </FormControl>
                    </Box>

                    <Typography gutterBottom variant={"h2"} component={"h2"}>
                        Types of cookie we use
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        We use 2 types of cookies:
                    </Typography>
                    <List>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Technical cookies"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Analytics cookies"}/></ListItem>
                    </List>

                    <Typography gutterBottom variant={"h2"} component={"h2"}>
                        Technical cookies
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        The technical cookies we might store are necessary for our website to function correctly. Therefore, we consider them as mandatory and we install them by default on your device.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        We may place 2 technical cookies on your device if you use the tutorial we offer you via the Help menu.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        The cookies placed are named “eup_hlp” and “eup_hlpxs”.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        They stay for the duration of the session only.
                    </Typography>

                    <Typography gutterBottom variant={"h2"} component={"h2"}>
                        Analytics cookies
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        The analytics cookies we might store on your device aim to collect statistical information about our website.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        These cookies are optional.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        You may accept or refuse our analytics cookies via the consent banner displayed at the bottom of the page on our websites, or via the widget proposed on the top of this page.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        We do not store analytics cookies without your prior consent.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        If you decide not to express your agreement, i.e. by ignoring the question, we will not store any cookies.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        If you change your mind afterwards, you may change your initial selection via the widget available here above.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        If you prefer not to be tracked, you can also activate the ‘Do not track’ feature available in all browsers.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        We have selected the Web Analytics tool of AT Internet (a Piano company) to monitor your navigation and to improve the quality of your browsing experience. This tool helps us to prepare aggregated and anonymous statistical reports.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        We have configured this tool in order to limit the collection of our users’ personal data as much as possible. For instance, we have implemented IP address de-identification by automatically truncating the last octet (the last 3 digits) of each visitor’s IP (internet protocol) address, making it impossible to identify visitors solely from their IP addresses.
                    </Typography>
                    <Typography variant={"body1"} component={"p"}>
                        Our analytics cookies collect the following information:
                    </Typography>
                    <List>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"IP address (anonymised)"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Sources (types, campaigns, domains, etc.)"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Content being viewed (title of the page, editorial page settings, path of pages, URL and canonical URL, language, etc.)"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Geolocation (country, region, town)"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Technical profiles (devices, operating system, browsers, user’s screen size, etc.)"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Periods (date and time of the visit to the site, user’s time zone)"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Site search"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Events (clicks on our content, on action buttons, etc.)"}/></ListItem>
                        <ListItem><ListItemIcon><Bullet /></ListItemIcon><ListItemText primary={"Domains (links to an external website, referrer website)"}/></ListItem>
                    </List>
                    <Typography variant={"body1"} component={"p"}>
                        The list of our analytics cookies is the following; you may also consult the notice n° 789 of our web analytics tool in <Link href="https://www.europarl.europa.eu/data-protect/index.do">our Data Protection Register</Link> for further information.
                    </Typography>

                    <TableContainer component={Paper} className={classes.tableContainer}>
                        <Table aria-label="table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableHead1")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableHead2")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableHead3")}</TableCell>
                                    <TableCell className={classes.tableDuration}>{translate("cookies.message.tableHead4")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableRow1A")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow1B")}</TableCell>
                                    <TableCell>
                                        {translate("cookies.message.tableRow1C1")}
                                        <Link href={translate("cookies.message.tableRow1CUrl")} target={"_blank"} rel="noopener noreferrer">{translate("cookies.message.tableRow1CLink")}</Link>
                                        {translate("cookies.message.tableRow1C2")}
                                    </TableCell>
                                    <TableCell>{translate("cookies.message.tableRow1D")}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableRow2A")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow2B")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow2C")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow2D")}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableRow3A")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow3B")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow3C")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow3D")}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableRow4A")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow4B")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow4C")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow4D")}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableRow5A")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow5B")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow5C")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow5D")}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableRow6A")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow6B")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow6C")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow6D")}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>{translate("cookies.message.tableRow7A")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow7B")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow7C")}</TableCell>
                                    <TableCell>{translate("cookies.message.tableRow7D")}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CookiesContent;
